import { render, staticRenderFns } from "./NewDocumentEditor.vue?vue&type=template&id=6daea81a&scoped=true&"
import script from "./NewDocumentEditor.vue?vue&type=script&lang=ts&"
export * from "./NewDocumentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./NewDocumentEditor.vue?vue&type=style&index=0&id=6daea81a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daea81a",
  null
  
)

export default component.exports